import { useEffect, useRef } from 'react';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertTriangle } from 'lucide-react';
import { useStrings, t } from '@/hooks/useStrings';

type Props = { onReset: () => void };

export const ErrorView = ({ onReset }: Props) => {
	const strings = useStrings();
	const ref = useRef<HTMLHeadingElement | null>(null);

	useEffect(() => {
		if (ref.current) ref.current.focus();
	}, []);

	return (
		<section aria-live="polite" role="alert">
			<Alert variant="destructive" className="tw:mb-4">
				<AlertTriangle className="tw:h-4 tw:w-4" />
				<AlertTitle ref={ref} tabIndex={-1} className="tw:text-lg">
					{t(strings, 'error_title', 'Es ist ein Fehler aufgetreten')}
				</AlertTitle>
				<AlertDescription>
					{t(strings, 'error_intro', 'Ihr Widerruf konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut oder wenden Sie sich an unseren Kundenservice.')}
				</AlertDescription>
			</Alert>

			<Button type="button" variant="outline" onClick={onReset}>
				{t(strings, 'error_retry', 'Zurück zum Formular')}
			</Button>
		</section>
	);
};
